import styled from 'styled-components';
import {
    FONT_FAMILY_DEMI,
    FONT_FAMILY_REGULAR,
    SMALL_TEXT_PX,
    X_SMALL_TEXT_PX,
    PRIMARY_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    LARGE_TEXT_PX,
    BASE_TEXT_PX
} from 'src/styles/fonts/MCFontConstants';

export const SetContentTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    border-bottom: 1px solid #ddd;
    table-layout: fixed;
`;

export const DesktopTableWrap = styled.div`
    display: block;
    max-width: 100%;

    @media (max-width: 767px) {
        display: none;
    }
`;

export const SetContentHeader = styled.div`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${LARGE_TEXT_PX};
    margin-bottom: 10px;
    @media (max-width: 767px) {
        padding: 16px 16px 0 16px;
        margin-bottom: 0px;
    }
`;

export const SetContentTableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 10;
`;

export const SetContentTableHeaderCell = styled.th`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${X_SMALL_TEXT_PX};
    font-weight: bold;
    padding: 12px 8px;    
    text-align: ${({ textAlign }) => (textAlign ? textAlign : 'left')};
    border-bottom: 1px solid #ddd;
    white-space: ${({ $twoLine }) => ($twoLine ? 'normal' : 'nowrap')};
    word-break: ${({ $twoLine }) => ($twoLine ? 'normal' : 'break-word')};
    width: ${({ width }) => width || 'auto'};
    box-sizing: border-box;

    @media (max-width: 1024px) {
        font-size: ${X_SMALL_TEXT_PX};
        padding: 10px 4px;
        width: ${({ tabWidth }) => tabWidth || '4%'};
    }

    @media (max-width: 767px) {
        font-size: 10px;
        padding: 8px 6px;
    }
`;

export const SetContentTableBody = styled.tbody``;

export const SetContentTableRow = styled.tr`
    &:hover {
        background-color: #fafafa;
    }

    &:nth-child(odd) {
        background-color: ${({ $isHeader }) => ($isHeader ? 'transparent' : '#fbfbfb')};
    }

    &:nth-child(even) {
        background-color: ${({ $isHeader }) => ($isHeader ? 'transparent' : '#ffffff')};
    }

    @media (max-width: 767px) {
        display: block;
        border-bottom: 2px solid #ddd;
        margin-bottom: 1em;
    }
`;

export const SetContentTableCell = styled.td`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${({ $fontFamily }) => ($fontFamily ? $fontFamily : FONT_FAMILY_REGULAR)};
    font-size: ${SMALL_TEXT_PX};
    padding: 12px 8px;
    border-bottom: 1px solid #DEDEE4;
    text-align: ${({ $textAlign }) => ($textAlign ? $textAlign : 'left')};
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: ${({ $noWrap }) => ($noWrap ? 'nowrap' : 'normal')};
    word-break: ${({ $noWrap }) => ($noWrap ? 'normal' : 'break-word')};
    overflow-wrap: ${({ $noWrap }) => ($noWrap ? 'normal' : 'anywhere')};
    box-sizing: border-box;

    @media (max-width: 1024px) {
        font-size: ${SMALL_TEXT_PX};
        padding: 10px 4px;
    }

    @media (max-width: 767px) {
        display: block;
        padding-left: 50%;
        position: relative;
        font-size: 12px;
        padding: 8px 6px;

        &::before {
            content: attr(data-label);
            position: absolute;
            left: 6px;
            font-weight: bold;
            width: 40%;
            white-space: normal;
        }
    }
`;

export const SetContentEmptyMessage = styled.div`
    color: ${SECONDARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    padding: 20px;
    text-align: center;
`;

export const DescriptionText = styled.span`
    display: inline;
    color: ${PRIMARY_FONT_COLOR};
`;

export const DescriptionTooltipWrapper = styled.div`
    max-width: ${({ $maxLength }) => ($maxLength ? `${$maxLength}ch` : '100%')};

    #tooltip-text {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 0;
    }

    #tooltip-text span {
        display: inline-block;
        flex: 1;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
    }
`;

export const DescriptionDots = styled.span`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    user-select: none;
`;

export const MobileCardList = styled.div`
    display: none;

    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        margin-top: 8px;
    }
`;

export const MobileCard = styled.div`
    border-bottom: 1px solid #e4e4ea;
    background: ${({ $isEven }) => ($isEven ? '#FAFBFB' : '#FFFFFF')};
    padding: 20px 12px;
`;

export const MobileCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const MobileCardLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const MobileCardChevron = styled.button`
    border: none;
    background: transparent;
    padding: 0;
    width: 32px;
    height: 32px;
    border: 1px solid #DEDEE4;
    border-radius: 6px;
    transform: ${({ $expanded }) => ($expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
    transition: transform 0.2s ease;
`;

export const MobileCardTitle = styled.div`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${BASE_TEXT_PX};
`;

export const MobileCardBody = styled.div`
    padding-top: 10px 20px;
`;

export const MobileCardField = styled.div`
    padding: 6px 0;

    &:last-child {
        padding-bottom: 0;
    }
`;

export const MobileCardFieldRow = styled.div`
    display: flex;
    gap: 10px;
`;

export const MobileFieldLabel = styled.div`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${BASE_TEXT_PX};
    width: 100px;
`;

export const MobileFieldValue = styled.div`
    color: ${PRIMARY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${BASE_TEXT_PX};
`;
